import JobTitlePage from "./JobTitlePage";

export default [{ path: "/job-title", element: <JobTitlePage /> }];
